import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import mdToHtml from "../utils/mdToHtml";

import { Image } from 'components';
import { media } from "utils/media";

const SimpleTextMedia = ({
  enabled,
  title,
  text,
  image,
  reverse
}) => {
  if(!enabled) return false;

  return (
    <div className={cx('section-wrapper', { reverse })}>
      <div className='section-text t-center mx-a'>
        <Image url={media("/media/icon_check.svg")} alt='Icon Check' className='icon-check mx-a mb-20' />
        <h2 dangerouslySetInnerHTML={{ __html: title }} />
        <div className='mt-20 mb-40' dangerouslySetInnerHTML={{ __html: mdToHtml(text) }} />
      </div>
      <div className='section-media'>
        <Image url={image.url} alt={image.alt} />
      </div>
    </div>
  );
};

SimpleTextMedia.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    noBlur: PropTypes.bool,
  }).isRequired,
  reverse: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
};

SimpleTextMedia.defaultProps = {
  reverse: false,
  className: '',
};

export default SimpleTextMedia;
